// extracted by mini-css-extract-plugin
export default {"bannerStyle":"installPwaButton_bannerStyle__zZbvU","closeBtn":"installPwaButton_closeBtn__Bw4iS"};